import React from "react";
import { connect } from "react-redux";
import { initialiseUserDetails } from "../../state/system/Session";
import { IAppState } from "../../state/Store";
import { initialiseSchoolDetails } from "../../state/core/School";
import Configuration from "../../foundation/Configuration";
import AppState from "../../foundation/AppState";

import "./Header.scss";

interface HeaderProps {
    file: string;
    school: string;
    route: string;
    reportName: string;

    appLogo: string;
    flatLogo: string;

    initialiseUserDetails?: Function;
    initialiseSchoolDetails?: Function;
}

interface HeaderState {}

class Header extends React.Component<HeaderProps, HeaderState> {
    state = {};

    constructor(props: HeaderProps) {
        super(props);

        props.initialiseUserDetails();
        props.initialiseSchoolDetails();
    }

    render() {
        return (
            <div className="page-header">
                <img
                    className="nav-button"
                    src={this.props.flatLogo}
                    alt="App Logo"></img>
                <div className="school-title print-only">
                    {this.props.school}
                </div>
                <div className="page-title">
                    <p className="no-print">
                        {Configuration.friendlyName} / {this.props.file}
                    </p>
                    <p className="no-print page-title-tail">
                        &nbsp;/&nbsp;{this.props.route}
                    </p>
                    <p className="report-title print-only">
                        {this.props.reportName.replace(
                            "Report - ",
                            "Report: ",
                        ) || `Report: ${this.props.route ?? "Not Set"}`}
                    </p>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState) => {
    const { menu, ui } = state.db;
    const { session } = state.session;

    return {
        file: Configuration.fileBased
            ? session.file?.name ?? "No file selected"
            : AppState.jwt?.school,
        school: AppState.jwt?.school,
        route: menu.selected?.name,
        reportName: ui.reportName,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        initialiseUserDetails: () => dispatch(initialiseUserDetails()),
        initialiseSchoolDetails: () => dispatch(initialiseSchoolDetails()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
